import { useState, useCallback } from 'react'
import { lang } from 'utils/helpers'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import resourcesActions from '../../../../redux/resources/actions'
import sharedResourcesAct from 'redux/actions/conversations/plugins/sharedResourcesAct'

export function usePluginResources(resourceType) {
  const isSharedFiles = resourceType === 'sharedFiles'
  const { push } = useHistory()
  const dispatch = useDispatch()
  const { activeUser } = useSelector((store) => store.tabs)
  const { companyResources, isLoading: isLoadingResources, isOpen: isOpenResources, resourcesToDownload } = useSelector((store) => store.resources)
  const userConversation = useSelector((store) => store.conversations[activeUser])
  const { plugins } = userConversation || {}
  const sharedResources = plugins?.sharedResources || {}

  const [filterSelect, setFilterSelect] = useState('')
  const [sortSelect, setSortSelect] = useState('')
  const [searchParam, setSearchParam] = useState('')
  const [fileEditMode, setFileEditMode] = useState(-1)
  const [fileEditNewName, setFileEditNewName] = useState('')
  const [isOpenMenuOptions, setIsOpenMenuOptions] = useState({})

  const resources = isSharedFiles ? (sharedResources ? sharedResources.sharedResources || [] : []) : companyResources
  const isLoading = isSharedFiles ? sharedResources?.isLoading || false  : isLoadingResources
  const isOpen = isSharedFiles ? sharedResources?.isOpen || false  : isOpenResources
  const selectedResources = isSharedFiles ? (sharedResources ? sharedResources.sharedResourcesToDownload || [] : []) : resourcesToDownload

  const fileFields = [
    {
      value: '',
      label: lang('dashboard_type')
    },
    {
      value: 'name',
      label: lang('dashboard_name')
    },
    {
      value: 'createdAt',
      label: lang('dashboard_creation-date')
    },
    {
      value: 'modifiedAt',
      label: lang('general_modifiedDate')
    }
  ]

  const fileSort = [
    { value: 'asc', label: lang('order_by_az') },
    { value: 'desc', label: lang('order_by_za') }
  ]

  const searchWithParams = (field = '', sort = '', search = '') => {
    if (isSharedFiles) {
      dispatch(sharedResourcesAct.get({ field, sort, search }))
    } else {
      dispatch(resourcesActions.get({ field, sort, search }))
    }
  }

  const closePlugin = () => {
    if (isSharedFiles) {
      dispatch(sharedResourcesAct.close())
    } else {
      dispatch(resourcesActions.close())
    }
  }

  const selectFile = (file) => dispatch(sharedResourcesAct.uploadFile({ file }))

  const toggleCard = useCallback(() => {
    if (isOpen) {
      closePlugin()
    } else {
      searchWithParams()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isOpen])

  const searchQuery = (value) => {
    setSearchParam(value)
    searchWithParams('', '', value)
  }

  const handleChangeFileName = (file) => {
    if (file.name !== fileEditNewName) {
      dispatch(sharedResourcesAct.updateFileName({ fileId: file._id, newFileName: fileEditNewName }))
    }
    setFileEditMode(-1)
  }

  const handleDownload = (file, fileName = '') => {
    fetch(file).then(response => response.blob()).then(blob => {
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(blobUrl)
      document.body.removeChild(link)
    }).catch(error => console.error('Error downloading the file:', error))
  }
  
  const handleDownloadAll = () => {
    if (isSharedFiles) {
      dispatch(sharedResourcesAct.handleDownloadMultipleSharedResources())
    } else {
      dispatch(resourcesActions.handleDownloadMultipleResources())
    }
  }

  const handleDownloadAllAsZip = () => {
    if (isSharedFiles) {
      dispatch(sharedResourcesAct.handleDownloadMultipleSharedResourcesAsZip())
    } else {
      dispatch(resourcesActions.handleDownloadMultipleResourcesAsZip())
    }
  }
  
  const onSelectResource = (file) => {
    if (isSharedFiles) {
      dispatch(sharedResourcesAct.handleCheckSharedResourcesToDownload(file))
    } else {
      dispatch(resourcesActions.handleCheckResourcesToDownload(file))
    }
  }

  const onToggleDotsOptions = (e, id) => {
    if (e) e.stopPropagation()
    setIsOpenMenuOptions(prevState => id ? { ...prevState, [id]: !prevState[id] } : {})
  }

  const getMenuOptions = (index) => {
    const menuOptions = [{
      id: 'download',
      name: lang('dashboard_download_attachment'),
      onClick: () => handleDownload(resources[index]?.urlLong || resources[index]?.url, resources[index]?.name || '')
    }]

    if (isSharedFiles) {
      menuOptions.unshift({
        id: 'edit',
        name: lang('dashboard_edit'),
        onClick: (e) => {
          if (e) e.stopPropagation()
          document.getElementById('modal-portal').style.display = 'none' // WE SHOULD STOP USING THIS
          onToggleDotsOptions(e, `${resourceType}_${resources[index]._id}_${index}`)
          setFileEditNewName(resources[index].name)
          setFileEditMode(index)
        }
      })
    }
    if (selectedResources.length > 1) {
      menuOptions.push({
        id: 'downloadAll',
        name: lang('dashboard_download_all'),
        onClick: handleDownloadAll
      })
      menuOptions.push({
        id: 'downloadAllZip',
        name: lang('dashboard_download_all_zip'),
        onClick: handleDownloadAllAsZip
      })
    }
    return menuOptions
  }

  const handleOpenFile = (url) => {
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }


  return {
    resources,
    isOpen,
    fileFields,
    filterSelect,
    fileSort,
    sortSelect,
    searchParam,
    fileEditMode,
    fileEditNewName,
    isOpenMenuOptions,
    handleRedirect: push,
    isLoading,
    setFileEditNewName,
    toggleCard,
    setFilterSelect,
    setSortSelect,
    searchWithParams,
    searchQuery,
    selectFile,
    handleChangeFileName,
    onToggleDotsOptions,
    handleOpenFile,
    selectedResources,
    onSelectResource,
    getMenuOptions,
  }
}
export default usePluginResources